import { api, badge, flashMessage, formatter, modal, translate } from './util';
import { searchFormHelper } from './search-form';
import { procedureHelper } from './procedure';

/**
 * Shared features of procedure groups.
 */
var procedureGroupHelper = (function ($) {
	var redirectToProcedureGroupDetail = function (event, response) {
		location.href = '/procedure-groups/' + response.procedureGroup.id;
	};

	var notificationSettingsSaved = function (event, groupId, response) {
		updateNotificationSettings(
			$('.procedure-group[data-group-id=' + groupId + ']'),
			response.notificationSettings.notificationFrequency,
			response.notificationSettings.deadlinesEnabled
		);
		flashMessage.show('success', $('.notification-settings-modal').data('success-message'));
	};

	var updateNotificationSettings = function (procedureGroupContainer, notificationFrequency, enableDeadlines) {
		procedureGroupContainer.data('notification-frequency', notificationFrequency);
		procedureGroupContainer.data('notification-deadlines-enabled', enableDeadlines);
		procedureGroupContainer
			.find('.btn-notification')
			.toggleClass('btn-notification-act', notificationFrequency !== 'disabled' || enableDeadlines);
	};

	var updateProcedureGroupName = function (event, response) {
		$('.procedure-group[data-group-id=' + response.procedureGroup.id + '] .procedure-group-name')
			.attr('title', response.procedureGroup.name)
			.text(response.procedureGroup.name);

		let ignoredProcedureGroup = response.procedureGroup.ignoredProcedureGroup;
		if (ignoredProcedureGroup != null) {
			$('.procedure-group[data-group-id=' + response.procedureGroup.id + '] .procedure-group-ignored').show();
			$('.procedure-group[data-group-id=' + response.procedureGroup.id + '] .procedure-group-ignored-name')
				.attr('title', ignoredProcedureGroup.name)
				.text(ignoredProcedureGroup.name);
		} else {
			$('.procedure-group[data-group-id=' + response.procedureGroup.id + '] .procedure-group-ignored').hide();
			$('.procedure-group[data-group-id=' + response.procedureGroup.id + '] .procedure-group-ignored-name')
				.attr('title', '')
				.text('');
		}

		modal.hide();
	};

	var createSaveFiltersApiRequest = function (groupId) {
		var values = searchFormHelper.getSearchFormValues();
		var operator = searchFormHelper.getOperatorValue();
		var withProductBrothers = searchFormHelper.isWithProductBrothers();
		var filters = [];

		for (var i = 0; i < values.length; i++) {
			filters.push({
				type: getFilterType(values[i].name),
				value: values[i].value,
			});
		}

		if (filters.length === 0) {
			filters.push({
				type: 'all',
				value: '',
			});
		}

		return api.put(
			'/users/' + encodeURIComponent(api.getUserId()) + '/procedure-groups/' + encodeURIComponent(groupId) + '/filters',
			{
				procedureGroupFilters: filters,
				operator: operator,
				withProductBrothers: withProductBrothers,
			}
		);
	};

	var getFilterType = function (name) {
		var type = name
			.replace('filter-', '')
			.split('-')
			.map(function (part) {
				return part.charAt(0).toUpperCase() + part.substring(1);
			})
			.join('');

		return type.charAt(0).toLowerCase() + type.substring(1);
	};

	return {
		redirectToProcedureGroupDetail: redirectToProcedureGroupDetail,
		notificationSettingsSaved: notificationSettingsSaved,
		updateNotificationSettings: updateNotificationSettings,
		updateProcedureGroupName: updateProcedureGroupName,
		createSaveFiltersApiRequest: createSaveFiltersApiRequest,
	};
})(jQuery);

/**
 * Features of procedure group list.
 */
var procedureGroupList = (function ($) {
	var root;

	var init = function () {
		root = $('.procedure-group-list');

		if (root.length === 0) {
			return;
		}

		root.find('.search-form-container').searchForm();
		root.find('.btn-create-procedure-group').createProcedureGroupModal('.create-procedure-group-modal');
		root.find('.content-list .btn-load-more').loadMore(getProcedureGroupsApiUrl(), createContainers);

		attachProcedureGroupContainerHandlers(root.find('.procedure-groups .procedure-group'));

		$(document).on('procedureGroup.created', procedureGroupHelper.redirectToProcedureGroupDetail);
		$(document).on('procedureGroup.notificationSettingsSaved', procedureGroupHelper.notificationSettingsSaved);
		$(document).on('procedureGroup.renamed', procedureGroupHelper.updateProcedureGroupName);
		$(document).on('procedureGroup.removed', removeProcedureGroupContainer);
	};

	var attachProcedureGroupContainerHandlers = function (procedureGroupContainers) {
		procedureGroupContainers.find('.btn-options').popover('.popover');
		procedureGroupContainers
			.find('.btn-notification')
			.procedureNotificationSettingsModal('.notification-settings-modal');
		procedureGroupContainers.find('.btn-deadlines').on('click', (e) => {
			window.location = $(e.target).data('href');
		});
		procedureGroupContainers.find('.popover .btn-rename').renameProcedureGroupModal('.rename-procedure-group-modal');
		procedureGroupContainers.find('.popover .btn-remove').removeProcedureGroupModal('.remove-procedure-group-modal');
	};

	var getProcedureGroupsApiUrl = function () {
		return '/users/' + encodeURIComponent(api.getUserId()) + '/procedure-groups';
	};

	/**
	 * Load next procedure group by AJAX.
	 *
	 * @param {object} event Event data.
	 * @param {string} groupId Id of removed procedure group.
	 */
	var removeProcedureGroupContainer = function (event, groupId) {
		root.find('.procedure-group[data-group-id=' + groupId + ']').remove();
		modal.hide();
		flashMessage.show('success', root.find('.remove-procedure-group-modal').data('success-message'));

		if (!root.find('.content-list .btn-load-more').is(':visible')) {
			return;
		}

		api
			.get(getProcedureGroupsApiUrl() + '?page=' + (root.find('.procedure-group').length + 1) + '&perPage=1')
			.done(createContainers);
	};

	var createContainers = function (response) {
		root.find('.content-list .btn-load-more').toggle(response.pagination.currentPage < response.pagination.totalPages);

		for (var i = 0; i < response.items.length; i++) {
			createContainer(response.items[i]);
		}
	};

	var createContainer = function (procedureGroup) {
		var procedureGroupsContainer = root.find('.procedure-groups:has(li.procedure-group)');
		var procedureGroupContainer = procedureGroupsContainer.find('.procedure-group:first').clone();
		var proceduresCount = procedureGroup.proceduresCount;
		var proceduresCountText = translate.selectForm(procedureGroupsContainer.data(), proceduresCount);

		procedureGroupContainer.attr('data-group-id', procedureGroup.id);
		procedureGroupContainer
			.find('.procedure-group-name')
			.attr('href', '/procedure-groups/' + procedureGroup.id)
			.attr('title', procedureGroup.name)
			.text(procedureGroup.name);
		procedureGroupContainer
			.find('.js-product-dashboard-export')
			.attr(
				'href',
				'/users/' + encodeURIComponent(api.getUserId()) + '/product/dashboard/procedure-group/' + procedureGroup.id
			);
		procedureGroupContainer
			.find('.js-procedure-dashboard-export')
			.attr('href', '/users/' + encodeURIComponent(api.getUserId()) + '/procedure/dashboard/' + procedureGroup.id);
		procedureGroupContainer.find('p').text(formatter.formatNumber(proceduresCount) + ' ' + proceduresCountText);

		procedureGroupHelper.updateNotificationSettings(
			procedureGroupContainer,
			procedureGroup.notification.settings.frequency,
			procedureGroup.notification.settings.deadlinesEnabled
		);
		attachProcedureGroupContainerHandlers(procedureGroupContainer);

		procedureGroupsContainer.append(procedureGroupContainer);
	};

	return {
		init: init,
	};
})(jQuery);

/**
 * Features of procedure group detail.
 */
var procedureGroupDetail = (function ($) {
	var root;

	var init = function () {
		root = $('.procedure-group-detail');

		if (root.length === 0) {
			return;
		}

		root.find('.btn-options').popover('.popover');
		root.find('.btn-notification').procedureNotificationSettingsModal('.notification-settings-modal');
		root.find('.popover .btn-rename').renameProcedureGroupModal('.rename-procedure-group-modal');
		root.find('.popover .btn-remove').removeProcedureGroupModal('.remove-procedure-group-modal');
		root.find('.btn-save').apiButton(createSaveFiltersApiRequestWithSpinner);
		root.find('.btn-cancel').click(cancelChangeFilters);
		root
			.find('.btn-history')
			.proceduresHistoryModal('.procedure-group-history-modal', getProcedureGroupUrl() + '/procedures-history');
		root.find('.btn-edit').click(openSearchForm);
		root.find('.procedure-table .table tbody tr').clickableRow('btn-detail');
		root
			.find('.procedure-table .btn-load-more')
			.loadMore(getProcedureGroupUrl() + '/procedures', procedureHelper.createProcedureTableRows);

		$(document).on('procedureGroup.notificationSettingsSaved', procedureGroupHelper.notificationSettingsSaved);
		$(document).on('procedureGroup.renamed', procedureGroupHelper.updateProcedureGroupName);
		$(document).on('procedureGroup.removed', redirectToProcedureGroupList);

		if (window.location.hash) {
			const modalName = window.location.hash.substring(1);
			root.find('.btn-notification').preOpenNotificationSettingsModal('.' + modalName);
		}
	};

	var getProcedureGroupId = function () {
		return root.find('.procedure-group').data('group-id');
	};

	var getProcedureGroupUrl = function () {
		return (
			'/users/' + encodeURIComponent(api.getUserId()) + '/procedure-groups/' + encodeURIComponent(getProcedureGroupId())
		);
	};

	/**
	 * Redirect to the procedure group list.
	 */
	var redirectToProcedureGroupList = function () {
		location.href = '/';
	};

	var openSearchForm = function () {
		root.find('.procedure-group-edit-close').hide();
		root.find('.procedure-group-edit-open').show();
		cloneSearchFormContainer();
	};

	var cloneSearchFormContainer = function () {
		// Clone the search form, so it is possible to cancel all changes with cancel button.
		// There is a problem with copying state of selects, so 'selected' attributed needs to be set.
		var originalSearchFormContainer = root.find('.search-form-container');
		originalSearchFormContainer.find('select').each(setOptionsSelectedAttribute);

		var searchFormContainer = originalSearchFormContainer.clone(true);
		root.find('.procedure-group-search-form').prepend(searchFormContainer);

		// Initialize the search form.
		searchFormContainer.show();
		searchFormContainer.searchForm();
	};

	var setOptionsSelectedAttribute = function () {
		$(this)
			.find('option')
			.each(function () {
				$(this).attr('selected', $(this).is(':selected'));
			});
	};

	var cancelChangeFilters = function () {
		// Remove the search form which has been cloned in the openSearchForm function and this way
		// effectively discard all changes in procedure group filters which should not be saved.
		var containers = root.find('.procedure-group-search-form .search-form-container');

		if (containers.length > 1) {
			containers.first().remove();
		}

		// Close the search form.
		closeSearchForm();
	};

	var closeSearchForm = function () {
		hideSearchFormContainer();
		root.find('.procedure-group-edit-open').hide();
		root.find('.procedure-group-edit-close').show();
	};

	var hideSearchFormContainer = function () {
		var searchFormContainer = root.find('.procedure-group-edit-open .search-form-container');
		searchFormContainer.searchForm('destroy');
		searchFormContainer.hide();
		badge.hide(root.find('.buttons .badge'));
	};

	var loadProcedures = function (url) {
		var procedureTableContainer = root.find('.procedure-table');
		var procedureTable = procedureTableContainer.find('.table');
		var loadingContainer = procedureTableContainer.find('.loading-container');

		procedureTable.hide();
		procedureTableContainer.find('.load-more').hide();
		procedureTableContainer.find('.no-results-container').hide();
		loadingContainer.show();

		api.get(url).done(function (response) {
			loadingContainer.hide();

			// Update the procedure table.
			procedureTable.find('tbody tr').remove();
			procedureHelper.createProcedureTableRows(response);
			procedureTable.find('tbody tr').clickableRow('btn-detail');

			// Update procedures count.
			root.find('.procedure-group-procedures-count').text(formatter.formatNumber(response.pagination.total));

			// Initialize the load more button.
			var loadMoreButton = procedureTableContainer.find('.btn-load-more');
			loadMoreButton.unbind('click');
			loadMoreButton.loadMore(url, procedureHelper.createProcedureTableRows);
			root.find('.btn-history').toggle(response.pagination.total > 0);
		});
	};

	var createSaveFiltersApiRequestWithSpinner = function () {
		root.find('.btn-cancel').prop('disabled', true);
		badge.show(root.find('.buttons .badge'), 'icon-spinner', 'spinner-text');

		return $.when($(document).delay(500)).done(createSaveFiltersApiRequest);
	};

	var createSaveFiltersApiRequest = function () {
		return procedureGroupHelper.createSaveFiltersApiRequest(getProcedureGroupId()).done(function () {
			if ($('.procedure-table').length === 0) {
				location.reload();
				return;
			}

			root.find('.btn-cancel').prop('disabled', false);

			// Remove the old (not cloned) search form and thus preserve the changes of the
			// procedure group filters.
			var containers = root.find('.procedure-group-search-form .search-form-container');

			if (containers.length > 1) {
				containers.last().remove();
			}

			hideSearchFormContainer();
			cloneSearchFormContainer();
			loadProcedures(getProcedureGroupUrl() + '/procedures');

			badge.show(root.find('.buttons .badge'), 'icon-saved', 'saved-text', 5000);
		});
	};

	return {
		init: init,
	};
})(jQuery);

export { procedureGroupHelper, procedureGroupList, procedureGroupDetail };
